import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { INeighbourhoodSchema } from '../../../types';
import { isArrayWithItems } from '../../../utils/helpers';

// должны совпадать с --block_width_desktop, --block_width_mobile и --block_padding в index.css
const IMAGE_WIDTH_DESKTOP = 119;
const IMAGE_WIDTH_MOBILE = 94;
const BLOCK_PADDING = 4;

// оптимальное число чтобы в ssr что-то отрисовалось в html
// на десктопе больше не вместится
// на мобилке для ширины 720px влезает 5, если больше то 4 и кнопка "еще"
const INIT_COUNT_IMAGES = 6;

export interface IThumbsGalleryProps {
  thumbs: INeighbourhoodSchema[];
  isMobileVersion?: boolean;
  onSlideClick(index: number): void;
}

interface IThumbsGalleryState {
  maxItems: number;
  showMoreButton: boolean;
  maxWidth?: number;
}

export class ThumbsGallery extends React.Component<IThumbsGalleryProps, IThumbsGalleryState> {
  private wrapper: React.RefObject<HTMLDivElement> = React.createRef();

  public state = {
    maxItems: INIT_COUNT_IMAGES,
    maxWidth: undefined,
    showMoreButton: false,
  };

  public componentDidMount() {
    this.updateMaxItems();
    window.addEventListener('resize', this.updateMaxItems);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.updateMaxItems);
  }

  public render() {
    const { thumbs, onSlideClick, isMobileVersion } = this.props;
    const { maxItems, maxWidth, showMoreButton } = this.state;
    if (!isArrayWithItems(thumbs)) {
      return <div />;
    }

    const thumbsInlineStyles = {
      maxWidth,
    };

    return (
      <div {...mergeStyles(styles['thumbs-wrapper'], isMobileVersion && styles['thumbs-wrapper--mobile'])}>
        <div {...mergeStyles(styles['thumbs'], thumbsInlineStyles)} ref={this.wrapper}>
          {thumbs.slice(0, maxItems).map((item, index) => (
            <img
              {...mergeStyles(styles['thumbs-img'], isMobileVersion && styles['thumbs-img-mobile'])}
              key={index}
              src={item.thumbnailUrl}
              alt={item.description}
              onTouchEnd={() => onSlideClick(index)}
              onMouseUp={() => onSlideClick(index)}
            />
          ))}
          {showMoreButton && (
            <div
              className={styles['more']}
              onTouchEnd={() => onSlideClick(maxItems)}
              onMouseUp={() => onSlideClick(maxItems)}
            >
              <span className={styles['more-text']}>Ещё...</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  private getImageWidth = () => {
    return this.props.isMobileVersion ? IMAGE_WIDTH_MOBILE : IMAGE_WIDTH_DESKTOP;
  };

  private updateMaxItems = () => {
    const { thumbs } = this.props;

    const blockWidth = this.getImageWidth() + BLOCK_PADDING;
    const totalItems = thumbs.length;

    if (this.wrapper.current && totalItems) {
      const { clientWidth } = this.wrapper.current;

      const totalGalleryWidth = totalItems * blockWidth;
      const showMoreButton = totalGalleryWidth > clientWidth;
      if (showMoreButton) {
        const galleryWidth = clientWidth - blockWidth;
        const maxItems = Math.floor(galleryWidth / blockWidth);
        this.setState({
          maxWidth: undefined,
          maxItems,
          showMoreButton,
        });
      } else {
        this.setState({
          maxWidth: totalGalleryWidth,
          maxItems: totalItems,
          showMoreButton,
        });
      }
    }
  };
}
